import merge from 'lodash/merge';
import clone from 'lodash/clone';
import isMobile from '../lib/isMobile';
import fluxDefaults from './defaults';

const mobile = isMobile();

module.exports = merge(clone(fluxDefaults, true), {
    gravity: 4,
    particleScale: 0.48,
    particlesRadius: 0.05,
    initialTicks: 100,
    walls: [
        // left
        {
            x: '0%',
            y: '0%',
            width: '1%',
            height: '100%',
        },
        // right
        {
            x: '99%',
            y: '0%',
            width: '1%',
            height: '100%',
        },
        // top
        {
            x: '-2%',
            y: '5%',
            width: '10%',
            height: '1%',
            angle: 45,
        },
        // {
        //     x: '9%',
        //     y: '6%',
        //     width: '10%',
        //     height: '1%',
        //     angle: 30,
        // },
        {
            x: '15%',
            y: '5%',
            width: '10%',
            height: '1%',
            angle: 10,
        },
        {
            x: '8%',
            y: '9%',
            width: '10%',
            height: '1%',
            angle: 10,
        },
        {
            x: '32%',
            y: '7%',
            width: '10%',
            height: '1%',
            angle: 45,
        },
        {
            x: '73%',
            y: '12%',
            width: '25%',
            height: '1%',
            angle: -45,
        },
        {
            x: '25%',
            y: '8%',
            width: '10%',
            height: '1%',
            angle: 65,
        },
        {
            x: '40%',
            y: '2%',
            width: '60%',
            height: '1%',
            angle: -1,
        },
        // bottom
        {
            x: '0%',
            y: '99%',
            width: '100%',
            height: '1%',
        },
        // slider
        // {
        //     x: '2%',
        //     y: '8%',
        //     width: '25%',
        //     height: 10,
        //     angle: 45,
        // },
        // box
        {
            x: '20.5%',
            y: '19.7%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '22%',
            y: '21%',
            width: '14%',
            height: '1%',
        },
        {
            x: '40.5%',
            y: '21%',
            width: '10%',
            height: '1%',
        },
        {
            x: '54.5%',
            y: '21%',
            width: '10%',
            height: '1%',
        },
        {
            x: '67.5%',
            y: '21%',
            width: '10%',
            height: '1%',
        },
        {
            x: '72.3%',
            y: '19%',
            width: '8%',
            height: '1%',
            angle: 90,
        },

        {
            x: '38.5%',
            y: '18.8%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '55%',
            y: '18.5%',
            width: '8%',
            height: '1%',
            angle: 90,
        },

        // top wall
        {
            x: '30.1%',
            y: '27.7%',
            width: '31%',
            height: '1%',
            angle: -17,
        },
        {
            x: '60.6%',
            y: '25.2%',
            width: '5%',
            height: '1%',
            angle: 1,
        },
        {
            x: '64.8%',
            y: '24.6%',
            width: '5%',
            height: '1%',
            angle: 135,
        },

        // multi level
        {
            x: '29%',
            y: '33.5%',
            width: '40%',
            height: '1%',
        },
        {
            x: '25.2%',
            y: '36.1%',
            width: '43%',
            height: '1%',
        },
        {
            x: '22%',
            y: '38.8%',
            width: '48%',
            height: '1%',
        },
        {
            x: '7%',
            y: '32%',
            width: '27%',
            height: '1%',
            angle: 87,
        },

        // right wall
        {
            x: '77%',
            y: '34.5%',
            width: '13%',
            height: '1%',
            angle: 105,
        },
        {
            x: '74%',
            y: '40%',
            width: '10%',
            height: '1%',
            angle: 135,
        },
        {
            x: '69%',
            y: '43%',
            width: '10%',
            height: '1%',
            angle: 150,
        },
        {
            x: '60%',
            y: '45%',
            width: '10%',
            height: '1%',
            angle: 170,
        },
        {
            x: '60%',
            y: '45%',
            width: '5%',
            height: '1%',
            angle: 180,
        },

        // left wall
        {
            x: '29%',
            y: '43.5%',
            width: '20%',
            height: '1%',
            angle: 2,
        },
        {
            x: '18%',
            y: '45.2%',
            width: '12%',
            height: '1%',
            angle: -30,
        },
        {
            x: '9%',
            y: '49.4%',
            width: '12%',
            height: '1%',
            angle: -50,
        },

        // funnel
        {
            x: '32.5%',
            y: '50%',
            width: '15%',
            height: '1%',
            angle: 48,
        },
        {
            x: '52%',
            y: '51%',
            width: '12%',
            height: '1%',
            angle: -48,
        },

        // main pipe
        {
            x: '43%',
            y: '54%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '52.5%',
            y: '54%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '32%',
            y: '63%',
            width: '30%',
            height: '1%',
            angle: 90,
        },
        {
            x: '50.7%',
            y: '57%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '38%',
            y: '69%',
            width: '30%',
            height: '1%',
            angle: 90,
        },
        {
            x: '35%',
            y: '90%',
            width: '40%',
            height: '1%',
            angle: 90,
        },

        // enterprise
        {
            x: '53%',
            y: '57.9%',
            width: '33%',
            height: '1%',
            angle: 0,
        },
        {
            x: '51%',
            y: '59.8%',
            width: '38%',
            height: '1%',
            angle: 0,
        },

        {
            x: '87.5%',
            y: '58%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '84.9%',
            y: '54%',
            width: '15%',
            height: '1%',
            angle: 90,
        },
        {
            x: '75%',
            y: '53%',
            width: '15%',
            height: '1%',
            angle: 90,
        },

        // enterprise funnel
        {
            x: '70%',
            y: '47%',
            width: '15%',
            height: '1%',
            angle: 45,
        },
        {
            x: '91%',
            y: '47%',
            width: '15%',
            height: '1%',
            angle: -45,
        },
        {
            x: '54%',
            y: '49%',
            width: '15%',
            height: '1%',
            angle: -50,
        },

        // olig
        {
            x: '52%',
            y: '76.8%',
            width: '38%',
            height: '1%',
            angle: 0,
        },
        {
            x: '51%',
            y: '78.9%',
            width: '46%',
            height: '1%',
            angle: 0,
        },
        {
            x: '93%',
            y: '78%',
            width: '5%',
            height: '1%',
            angle: 90,
        },
        {
            x: '95%',
            y: '76.5%',
            width: '5%',
            height: '1%',
            angle: -3,
        },
        {
            x: '79%',
            y: '75.5%',
            width: '8%',
            height: '1%',
            angle: 17,
        },
        {
            x: '67%',
            y: '69%',
            width: '22%',
            height: '1%',
            angle: 90,
        },
    ],
    movingWalls: [

    ],
    blobs: [
        // main blobs
        {
            x: '0%',
            y: '-600%',
            width: '100%',
            height: mobile ? '5%' : '10%',
            color: [0, 0, 0, 255],
        },
        {
            x: '0%',
            y: '-500%',
            width: '100%',
            height: mobile ? '5%' : '10%',
            color: [255, 0, 0, 255],
        },
        {
            x: '0%',
            y: '-400%',
            width: '100%',
            height: mobile ? '5%' : '10%',
            color: [0, 255, 0, 255],
        },
        {
            x: '0%',
            y: '-300%',
            width: '100%',
            height: mobile ? '2%' : '4%',
            color: [0, 0, 255, 255],
        },

        //
        {
            x: '90%',
            y: '55%',
            width: '10%',
            height: mobile ? '12%' : '24%',
            color: [0, 0, 0, 255],
        },

        {
            x: '90%',
            y: '40%',
            width: '10%',
            height: mobile ? '10%' : '20%',
            color: [0, 0, 0, 255],
        },
    ],
});



// WEBPACK FOOTER //
// ./js/flux/machine.js